import tippy from 'tippy.js';

export default function tooltip(node: HTMLElement, content: string | null | undefined) {
	let instance: ReturnType<typeof tippy>[0] | undefined;
	function apply(content: string | null | undefined) {
		instance?.destroy();
		if (!content) return;
		instance = tippy(node, {
			arrow: true,
			content,
			placement: 'top',
			appendTo: (node.getRootNode() as HTMLElement).querySelector('#modals')!,
			offset: [0, 8],
			duration: [0, 100],
		});
	}
	apply(content);

	return {
		update(content: string) {
			apply(content);
		},
		destroy() {
			instance?.destroy();
		},
	};
}
